/* mys-nav: behaviour of the opt-in header (snippets/mys-nav*.liquid, assets/mys-nav.css).
   Vanilla ES5, no dependencies. Responsibilities:
   1. desktop disclosure panels (hover with intent, click, keyboard)
   2. mobile drawer (focus trap, Esc, scroll lock, accordions)
   3. overflow guard: admin-controlled menu, switch to the compact bar when it does not fit
   4. scrolled shadow, 5. live cart count (Upcart event + cart request hook), 6. chat button. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mys-nav]');
  if (!root || root.__mysNav) return;
  root.__mysNav = true;

  var inner = root.querySelector('.mys-nav__inner');
  var list = root.querySelector('.mys-nav__list');
  var primary = root.querySelector('.mys-nav__primary');
  var drawer = root.querySelector('[data-mys-nav-drawer]');
  var burger = root.querySelector('[data-mys-nav-open]');
  var mq = window.matchMedia('(max-width: 1199px)');
  var noop = function () {};

  function all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function isCompact() { return mq.matches || root.classList.contains('is-compact'); }
  function calendarOpen() { return !!root.querySelector('.myselfie-datepicker__cal'); }
  function visible(el) { return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; }

  /* ---------- 1. Desktop disclosure panels ---------- */
  var items = all('.mys-nav__primary [data-mys-nav-item]');
  var openTimer = null;
  var closeTimer = null;

  function toggleOf(item) { return item.querySelector('[data-mys-nav-toggle]'); }
  function openItem(item) {
    items.forEach(function (other) { if (other !== item) closeItem(other); });
    item.setAttribute('data-open', '');
    toggleOf(item).setAttribute('aria-expanded', 'true');
  }
  function closeItem(item) {
    item.removeAttribute('data-open');
    toggleOf(item).setAttribute('aria-expanded', 'false');
  }
  function closeAll() { items.forEach(closeItem); }

  items.forEach(function (item) {
    var toggle = toggleOf(item);
    var panel = item.querySelector('[data-mys-nav-panel]');

    toggle.addEventListener('click', function () {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (item.hasAttribute('data-open')) closeItem(item); else openItem(item);
    });
    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || isCompact()) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openItem(item); }, 80);
    });
    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeItem(item); }, 220);
    });
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        openItem(item);
        var first = panel && panel.querySelector('a[href]');
        if (first) first.focus();
      }
    });
    item.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !item.hasAttribute('data-open')) return;
      e.preventDefault();
      closeItem(item);
      toggle.focus();
    });
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !item.contains(e.relatedTarget)) closeItem(item);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-mys-nav-item]')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawerOpen && !calendarOpen()) closeAll();
  });

  /* ---------- 2. Drawer ---------- */
  var drawerOpen = false;
  var lastFocus = null;

  function focusables() {
    return all('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer)
      .filter(visible);
  }
  function onDrawerKey(e) {
    if (e.key === 'Escape') {
      if (calendarOpen()) return; // the picker closes itself first
      e.preventDefault();
      closeDrawer(true);
    } else if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  function onFocusIn(e) {
    if (drawerOpen && !drawer.contains(e.target)) {
      var f = focusables();
      if (f.length) f[0].focus();
    }
  }
  function openDrawer() {
    if (drawerOpen) return;
    drawerOpen = true;
    lastFocus = document.activeElement;
    closeAll();
    root.setAttribute('data-drawer-open', '');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('mys-nav-locked');
    document.addEventListener('keydown', onDrawerKey);
    document.addEventListener('focusin', onFocusIn);
    requestAnimationFrame(function () {
      var target = drawer.querySelector('[data-mys-nav-initial-focus]');
      if (target) target.focus();
    });
  }
  function closeDrawer(restore) {
    if (!drawerOpen) return;
    drawerOpen = false;
    root.removeAttribute('data-drawer-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('mys-nav-locked');
    document.removeEventListener('keydown', onDrawerKey);
    document.removeEventListener('focusin', onFocusIn);
    if (restore && lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  if (burger) burger.addEventListener('click', openDrawer);
  all('[data-mys-nav-close]').forEach(function (el) {
    el.addEventListener('click', function () { closeDrawer(true); });
  });
  // Any navigation inside the drawer closes it. Never preventDefault: hash links and the
  // cart link (Upcart) must run their own default behaviour.
  drawer.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (a && !a.hasAttribute('data-mys-nav-chat')) closeDrawer(false);
  });
  all('[data-mys-nav-acc]', drawer).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var li = btn.closest('[data-mys-nav-acc-item]');
      var open = !li.hasAttribute('data-open');
      if (open) li.setAttribute('data-open', ''); else li.removeAttribute('data-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- 3. Overflow guard ---------- */
  var rafMeasure = 0;
  function measure() {
    var was = root.classList.contains('is-compact');
    root.classList.remove('is-compact');
    var over = false;
    if (!mq.matches && inner && list && primary) {
      over = inner.scrollWidth > inner.clientWidth + 1 || list.scrollWidth > primary.clientWidth + 1;
    }
    if (over) root.classList.add('is-compact');
    if (over !== was) {
      closeAll();
      // css-variables.liquid re-reads the .Navigation height (64 vs 74) on resize.
      window.dispatchEvent(new Event('resize'));
    }
    if (mq.matches || over) closeAll();
    if (!isCompact() && drawerOpen) closeDrawer(false);
  }
  function scheduleMeasure() {
    if (rafMeasure) return;
    rafMeasure = requestAnimationFrame(function () { rafMeasure = 0; measure(); });
  }
  measure();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleMeasure);
  window.addEventListener('resize', scheduleMeasure);
  window.addEventListener('load', scheduleMeasure);
  if (mq.addEventListener) mq.addEventListener('change', scheduleMeasure);
  else if (mq.addListener) mq.addListener(scheduleMeasure);

  /* ---------- 4. Scrolled state ---------- */
  var scrollTick = 0;
  function onScroll() {
    if (scrollTick) return;
    scrollTick = requestAnimationFrame(function () {
      scrollTick = 0;
      root.classList.toggle('is-scrolled', (window.pageYOffset || document.documentElement.scrollTop) > 4);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- 5. Cart count (Upcart) ----------
     The count = the quantities of the lines that cost money (owner 2026-10-05): free props, the prop holder and the
     0 kr "Myselfie Logo" line are not counted. Server-rendered by snippets/mys-cart-paid-count.liquid; the
     "myselfie:cart" detail carries it as paid_count (assets/myselfie-checkout.js KIT.paidCount). The "Gå til
     betaling" mode follows the same number: a cart with paid items. */
  function setCount(n) {
    n = +n || 0;
    root.classList.toggle('has-items', n > 0);
    all('[data-mys-nav-count]').forEach(function (el) {
      el.textContent = n;
      if (n === 0) el.setAttribute('data-empty', ''); else el.removeAttribute('data-empty');
    });
    all('[data-mys-nav-cart]').forEach(function (a) {
      var label = a.getAttribute('data-label');
      if (!label) return;
      var text = label.replace('__N__', n);
      a.setAttribute('aria-label', text);
      var span = a.querySelector('[data-mys-nav-cart-text]');
      if (span) span.textContent = text;
    });
    // "Gå til betaling" mode: label only, the target stays the booking module (section 7)
    all('[data-mys-nav-book]').forEach(function (a) {
      var t = a.getAttribute(n > 0 ? 'data-mys-nav-pay' : 'data-mys-nav-book');
      if (t && a.textContent !== t) a.textContent = t;
    });
    if (n === 0) root.removeAttribute('data-cart-mode'); else root.setAttribute('data-cart-mode', 'pay');
  }
  // Sources of truth, no polling:
  // a) Upcart's public event. Its payload is {cart:{items:[{quantity}]}} (no item_count) and it only
  //    fires for adds and Upcart's own drawer edits, not for /cart/change.js or /cart/clear.js fetches.
  // b) a passive hook on fetch + XHR: any request to /cart/add|change|update|clear schedules one
  //    debounced GET /cart.js (theme code: mys-rek.js, myselfie-booking-calendar.js, jQuery, apps).
  // c) document 'cart:refresh' (mys-rek.js) and bfcache restores.
  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;
  var nativeFetch = window.fetch;
  var refetchTimer = 0;
  var refetchSeq = 0;

  /** Price of a cart line (øre); a line without any price field counts as paid. */
  function linePrice(it) {
    if (typeof it.final_line_price === 'number') return it.final_line_price;
    if (typeof it.line_price === 'number') return it.line_price;
    if (typeof it.final_price === 'number') return it.final_price * (+it.quantity || 0);
    return typeof it.price === 'number' ? it.price * (+it.quantity || 0) : 1;
  }
  /** Quantities of the lines that cost money (KIT.paidCount). */
  function countItems(items) {
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it && linePrice(it) > 0) n += +it.quantity || 0;
    }
    return n;
  }
  function fromPayload(data) {
    var c = data && data.cart ? data.cart : data;
    if (!c) return;
    if (typeof c.paid_count === 'number') setCount(c.paid_count);
    else if (c.items && typeof c.items.length === 'number') setCount(countItems(c.items));
    else if (typeof c.item_count === 'number') setCount(c.item_count);
  }
  function refetch() {
    if (!nativeFetch) return;
    var seq = ++refetchSeq;
    nativeFetch.call(window, ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (seq === refetchSeq && c && c.items) setCount(countItems(c.items)); })
      .catch(noop);
  }
  function scheduleRefetch() {
    clearTimeout(refetchTimer);
    refetchTimer = setTimeout(refetch, 250);
  }
  function isCartWrite(u) {
    try {
      var url = new URL(String(u), location.href);
      // the free-props sync (KIT.FREE_PROPS_TAG) only writes 0 kr lines: the count cannot change
      return CART_WRITE.test(url.pathname) && url.search.indexOf('myselfie=free-props') < 0;
    } catch (err) { return false; }
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      var u = input && typeof input === 'object' && 'url' in input ? input.url : input;
      if (isCartWrite(u)) p.then(scheduleRefetch, scheduleRefetch);
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var xOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, u) {
      if (isCartWrite(u)) this.addEventListener('loadend', scheduleRefetch);
      return xOpen.apply(this, arguments);
    };
  }

  var upcartBound = false;
  function subscribeUpcart() {
    if (upcartBound || typeof window.upcartSubscribeCartUpdated !== 'function') return;
    try { window.upcartSubscribeCartUpdated(fromPayload); upcartBound = true; } catch (err) { /* ignore */ }
  }
  subscribeUpcart();
  window.addEventListener('load', subscribeUpcart);
  // Upcart is an async app embed: until its API exists, listen to the event it dispatches.
  window.addEventListener('aftersell-upcart:public-events:cart-updated', function (e) {
    if (!upcartBound) fromPayload(e && e.detail);
  });
  document.addEventListener('cart:refresh', scheduleRefetch);
  // theme cart writers (booking module, cart page, product page, season guard, cart rules):
  // {detail:{item_count, items_subtotal_price, paid_count, cart}} - paid_count is the count shown
  document.addEventListener('myselfie:cart', function (e) {
    var d = e && e.detail;
    if (!d) return;
    var n = typeof d.paid_count === 'number' ? d.paid_count : d.cart && d.cart.items ? countItems(d.cart.items) : d.item_count === 0 ? 0 : null;
    if (n == null) return; // an old-style detail (item_count only) cannot tell free lines apart: the hook's re-read decides
    refetchSeq++;
    setCount(n);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleRefetch(); });

  /* ---------- 6. Chat ---------- */
  all('[data-mys-nav-chat]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var ul = window.userlink;
      if (ul && typeof ul.setChatVisible === 'function') {
        e.preventDefault();
        closeDrawer(false);
        ul.setChatVisible(true);
      } else if (typeof window.setUserlinkChatVisible === 'function') {
        e.preventDefault();
        closeDrawer(false);
        window.setUserlinkChatVisible(true);
      } else {
        closeDrawer(false); // falls through to the contact page
      }
    });
  });

  /* ---------- 7. Booking routing: goToBooking() ----------
     One routing function for every way to the booking module (myselfie-product-selector):
     the Book CTAs (desktop button, compact "Book" pill, drawer CTA) and every link to it anywhere on
     the page ("Se ledige datoer": /#book-myselfie, https://myselfie.dk/#book-myselfie,
     /#packages, snippets/myselfie-booking-href.liquid). Module on this page -> close the drawer,
     scroll there (sticky-header offset, reduced motion) and move focus to it; otherwise navigate to
     /#book-myselfie. The CTA layer on top: in "Gå til betaling" mode (cart not empty) it lands on
     the module's summary / book button instead of the top. Without JS every href is the booking href. */
  // theme setting myselfie_booking_anchor (DK: book-myselfie); empty = no booking routing
  var BOOK_ID = root.getAttribute('data-booking-anchor') || '';
  var BOOK_HASHES = ['#' + BOOK_ID, '#packages', '#booking', '#book-din-myselfie']; // book-din-myselfie: legacy anchor before 3.0.8
  var SHOP_HOSTS = [location.host, 'myselfie.dk', 'www.myselfie.dk'];
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function shown(el) { return !!el && el.getClientRects().length > 0 && el.getBoundingClientRect().height > 0; }
  function headerOffset() {
    var bar = root.querySelector('.Navigation');
    return Math.max(0, bar ? bar.getBoundingClientRect().bottom : 0) + 12;
  }
  function docTop(el) { return el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop); }
  function scrollToY(y) {
    window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }
  function focusQuietly(el) {
    if (!el) return;
    if (!el.matches('a[href], button, input, select, textarea, [tabindex]')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
  }
  // the checkout part of the module: its summary when it has content, else its book button
  function payTarget(anchor) {
    var scope = anchor.closest('.shopify-section') || anchor.closest('section') || document;
    var summary = scope.querySelector('[data-ps-summary]');
    var book = scope.querySelector('[data-ps-book]');
    if (!shown(book)) book = null;
    if (!(shown(summary) && summary.textContent.trim())) summary = null;
    if (!summary && !book) return null;
    // summary at the top under the header, but never with the book button below the fold
    var y = docTop(summary || book) - headerOffset();
    if (book) y = Math.max(y, docTop(book) + book.getBoundingClientRect().height - window.innerHeight + 24);
    return { y: y, focus: book || summary };
  }
  function goToBooking(opts) {
    opts = opts || {};
    if (!BOOK_ID) return false;
    var anchor = document.getElementById(BOOK_ID);
    if (drawerOpen) closeDrawer(false);
    if (!anchor) {
      window.location.assign(ROOT + '#' + BOOK_ID);
      return false;
    }
    var pay = opts.pay ? payTarget(anchor) : null;
    if (pay) {
      scrollToY(pay.y);
      focusQuietly(pay.focus);
    } else {
      scrollToY(docTop(anchor) - Math.max(parseFloat(getComputedStyle(anchor).scrollMarginTop) || 0, headerOffset()));
      focusQuietly(anchor);
    }
    if (window.history.replaceState && location.hash !== '#' + BOOK_ID) {
      try { window.history.replaceState(null, '', location.pathname + location.search + '#' + BOOK_ID); } catch (err) { /* ignore */ }
    }
    root.setAttribute('data-booking-scrolled', pay ? 'pay' : 'top');
    return true;
  }
  window.myselfie = window.myselfie || {};
  window.myselfie.goToBooking = goToBooking;

  /** Cart page only: scroll to the cart column (sticky-header offset), focus it. False = not here. */
  function goToCart() {
    if (!document.body.classList.contains('template-cart')) return false;
    var cart = document.getElementById('jeres-kurv');
    if (!shown(cart)) return false;
    if (drawerOpen) closeDrawer(false);
    scrollToY(docTop(cart) - headerOffset());
    focusQuietly(cart);
    root.setAttribute('data-cart-scrolled', '');
    return true;
  }

  function isBookingLink(a) {
    var href = a.getAttribute('href');
    if (!href || href.indexOf('#') < 0) return false;
    var u;
    try { u = new URL(href, location.href); } catch (err) { return false; }
    if (BOOK_HASHES.indexOf(u.hash) < 0 || SHOP_HOSTS.indexOf(u.host) < 0) return false;
    var p = u.pathname.replace(/\/$/, '');
    return p === '' || p === ROOT.replace(/\/$/, '') || p === location.pathname.replace(/\/$/, '');
  }
  // capture phase on window: runs before the drawer's and the booking module's own (document) click
  // handlers, so a booking link scrolls exactly once. Modified / middle clicks keep their default.
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('download') || (a.target && a.target !== '_self')) return;
    // On the DK cart page the cart icon scrolls to "Jeres kurv" (#jeres-kurv) instead of reloading /cart
    // (owner decision 6, _qa/cartpage/spec.md). Every other page, and /cart?view=legacy: a plain link.
    if (a.hasAttribute('data-mys-nav-cart') && goToCart()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!BOOK_ID) return;
    // data-mys-nav-leave: a real link to the booking module on another page (DK /cart: "Ret dato/periode",
    // where #book-myselfie is the checkout block), never a same-page scroll
    if (a.hasAttribute('data-mys-nav-leave')) return;
    var cta = a.hasAttribute('data-mys-nav-book');
    if (!cta && !isBookingLink(a)) return;
    e.preventDefault();
    e.stopPropagation();
    goToBooking({ pay: cta && root.hasAttribute('data-cart-mode') });
  }, true);

  root.setAttribute('data-ready', '');
})();
